import React from 'react';
import { Container, Grid } from '@material-ui/core';
import { graphql, useStaticQuery } from 'gatsby';
import Link from 'gatsby-plugin-transition-link/AniLink';
import styles from './footer.module.scss';
import DefaultLink from '../../typeface/DefaultLink';
import Icon from '../Icon';
import Image from '../Image';
import DefaultParagraph from '../../typeface/DefaultParagraph';
import variables from '../../styles/variables.module.scss';
import { footer } from '../../data';

import logo from '../../assets/icons/logo-outlined-min.webp';
import logoFall from '../../assets/icons/logo-outlined-min.png';

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          name,
          address,
          zipCode,
          city,
          phone,
          mail,
        }
      }
    }
  `);

  const {
    mail, phone, address, zipCode, city, name,
  } = data.site.siteMetadata;

  return (
    <footer>
      <div className={styles.containerUpper}>
        <Container>
          <Grid
            container
            justify="center"
            alignItems="center"
            className={styles.containerInnerUpper}
          >
            <Grid item>
              <h4 className={styles.titleFooter}>{footer.title}</h4>
              <h4 className={styles.titleFooter}>{footer.text}</h4>
              <DefaultLink
                href={`mailto:${mail}`}
                color={variables.carbonBlack}
                style={{ margin: 'auto' }}
              >
                <h4 className={[styles.titleFooter, styles.titleLinkFooter].join(' ')}>{mail}</h4>
              </DefaultLink>
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className={styles.containerLower}>
        <Container maxWidth="lg">
          <Grid
            container
            alignItems="flex-end"
            justify="center"
            direction="column"
            className={styles.containerInnerLower}
          >
            <Grid item className={styles.containerInnerLowerUpper}>
              <Grid
                container
                alignItems="center"
                justify="space-between"
              >
                <Grid item xs={12} sm>
                  <Link fade to="/">
                    <Image
                      source={{ main: logo, fall: logoFall }}
                      alt="we app logo"
                      width="65px"
                      className={styles.logoFooter}
                    />
                  </Link>
                </Grid>
                <Grid item xs={12} sm="auto">
                  <Grid
                    container
                    justify="space-between"
                    alignItems="center"
                    className={styles.containerFooterInfoLeft}
                  >
                    <Grid item className={styles.containerText} xs={12} sm="auto">
                      <DefaultLink
                        href={`tel:${phone}`}
                        color={variables.cleanWhite}
                        className={styles.textMargin}
                      >
                        <DefaultParagraph
                          small
                          className={styles.defaultParagraph}
                        >
                          {phone}
                        </DefaultParagraph>
                      </DefaultLink>
                      <DefaultLink
                        href={`mailto:${mail}`}
                        color={variables.cleanWhite}
                        className={styles.textMargin}
                      >
                        <DefaultParagraph
                          small
                          className={styles.defaultParagraph}
                        >
                          {mail}
                        </DefaultParagraph>
                      </DefaultLink>
                    </Grid>
                    <Grid item xs={12} sm>
                      <DefaultParagraph
                        small
                        className={styles.defaultParagraph}
                      >
                        {name}
                      </DefaultParagraph>
                      <DefaultParagraph
                        small
                        className={styles.defaultParagraph}
                      >
                        {`${address}, ${zipCode} ${city}`}
                      </DefaultParagraph>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid
                container
                className={styles.containerSocialMedia}
                alignItems="center"
                spacing={2}
              >
                {
                footer.socialMedia.map(item => (
                  <Grid item key={item.icon}>
                    <a href={item.href} target="_blank" rel="noopener noreferrer">
                      <Icon type={item.icon} />
                    </a>
                  </Grid>
                ))
                }
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </div>
    </footer>
  );
};
export default Footer;
